/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_External_IdInputs */

const cs_ebr_pairing_external_id = /** @type {(inputs: Ebr_Pairing_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dle eBrána ID`)
};

const en_ebr_pairing_external_id = /** @type {(inputs: Ebr_Pairing_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by eBrána ID`)
};

/**
* | output |
* | --- |
* | "by eBrána ID" |
*
* @param {Ebr_Pairing_External_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_external_id = /** @type {((inputs?: Ebr_Pairing_External_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_External_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_external_id(inputs)
	return cs_ebr_pairing_external_id(inputs)
});